var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("@assets/images/bear.png")}}),_vm._v("\n  抱歉，出错了，请您稍后再试！\n")])}]

export { render, staticRenderFns }